// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__zJKN3","error":"styles_error__5-2pH"};